import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { CustomerRepoImpl } from "domain/repository/Company/CustomerRepoImpl";
import { RecalProcessAndGenRepoImpl } from "domain/repository/Recalculation/RecalProcessAndGenRepoImpl";
import { RecalProposalSetRepoImpl } from "domain/repository/RecalProposalSet/RecalProposalSetRepoImpl";
import { StandardTariffCodeRepoImpl } from "domain/repository/TariffCode/StandardTariffCodeRepoImpl";
import { TariffTypeRepoImpl } from "domain/repository/TariffCode/TariffTypeRepoImpl";
import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import { RecalProcessAndGenVM } from "presentation/viewModel/Recalculation/RecalProcessAndGenVM";
import { useMemo } from "react";

export const useRecalProcessAndGenVM = () => {
    const [, setRecalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const recalProcessAndGenVM = useMemo(() =>
        RecalProcessAndGenVM({
            dispatch: [setRecalProcessAndGenState],
            recalProcessAndGenRepo: RecalProcessAndGenRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            tariffTypeRepo: TariffTypeRepoImpl(),
            standardTariffCodeRepo: StandardTariffCodeRepoImpl(),
            recalProposalSetRepo: RecalProposalSetRepoImpl(),
            customerRepo: CustomerRepoImpl(),
        }), [setRecalProcessAndGenState])

    return recalProcessAndGenVM
}


